import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
let FreelancingProfiles = class FreelancingProfiles extends Vue {
    msg;
};
FreelancingProfiles = __decorate([
    Options({
        props: {
            msg: String,
        },
        components: {},
        data() {
            return {};
        },
        mounted() {
            console.log("mounted");
        },
        computed: {
            freelancing_profiles() {
                return this.$store.state.site_data.freelancingprofiles;
            },
        },
    })
], FreelancingProfiles);
export default FreelancingProfiles;
